import { VariantReader } from "aldoo-ra/VariantReader"
import Spinner from "aldoo-ra/Spinner"
import Tooltip from "aldoo-ra/Tooltip"
import { twMerge } from "tailwind-merge"
import { useState } from "react"

export default function Button({
  variant = "primary",
  styleOverrides,
  loading,
  children,
  onClick,
  disabled,
  className = "",
  confirm = false,
  confirmMessage = "Are you sure?", // Can be string or JSX/component
  "aria-label": ariaLabel,
}) {
  const [showConfirm, setShowConfirm] = useState(false)

  const variants = VariantReader.useVariant({
    componentName: "Button",
    variant,
    styleOverrides,
  })

  const handleClick = (e) => {
    if (confirm && !showConfirm) {
      setShowConfirm(true)
      return
    }

    setShowConfirm(false)
    onClick?.(e)
  }

  const handleBlur = () => {
    if (showConfirm) {
      setShowConfirm(false)
    }
  }

  const handleMouseLeave = () => {
    if (showConfirm) {
      setShowConfirm(false)
    }
  }

  const buttonContent = (
    <button
      disabled={disabled || loading}
      onClick={handleClick}
      onBlur={handleBlur}
      onMouseLeave={handleMouseLeave}
      className={twMerge(variants, className)}
      aria-label={ariaLabel}
    >
      {loading ? (
        <div className="flex items-center justify-center">
          <span className="invisible">{children}</span>
          <Spinner variant="button" className="absolute" />
        </div>
      ) : (
        showConfirm ? "Confirm" : children
      )}
    </button>
  )

  if (confirm) {
    return (
      <Tooltip
        content={
          <div className="bg-admin_primary rounded-lg px-4 py-3 shadow-lg">
            <div className="text-white font-medium">
              {confirmMessage}
            </div>
          </div>
        }
        position="top"
        display="inline-flex"
        isOpen={showConfirm}
        variant="none"
      >
        {buttonContent}
      </Tooltip>
    )
  }

  return buttonContent
}
